var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9242_35239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.09321 21C9.79832 21.6224 10.7246 22 11.739 22C12.7535 22 13.6797 21.6224 14.3848 21M12.739 2.08389C12.4107 2.02841 12.0763 2 11.739 2C10.1477 2 8.62162 2.63214 7.4964 3.75736C6.37118 4.88258 5.73904 6.4087 5.73904 8C5.73904 11.0902 4.95951 13.206 4.0887 14.6054C3.35417 15.7859 2.9869 16.3761 3.00036 16.5408C3.01528 16.7231 3.0539 16.7926 3.20081 16.9016C3.3335 17 3.93163 17 5.12789 17H18.3502C19.5464 17 20.1445 17 20.2772 16.9016C20.4241 16.7926 20.4627 16.7231 20.4776 16.5408C20.4911 16.3761 20.1238 15.7858 19.3892 14.6052C18.8972 13.8144 18.4343 12.7948 18.1247 11.5",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9242_35239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9068 21C13.2017 21.6224 12.2754 22 11.261 22C10.2465 22 9.32028 21.6224 8.61518 21M10.261 2.08389C10.5893 2.02841 10.9237 2 11.261 2C12.8523 2 14.3784 2.63214 15.5036 3.75736C16.6288 4.88258 17.261 6.4087 17.261 8C17.261 11.0902 18.0405 13.206 18.9113 14.6054C19.6458 15.7859 20.0131 16.3761 19.9996 16.5408C19.9847 16.7231 19.9461 16.7926 19.7992 16.9016C19.6665 17 19.0684 17 17.8721 17H4.64978C3.45358 17 2.85548 17 2.72278 16.9016C2.57588 16.7926 2.53728 16.7231 2.52238 16.5408C2.50888 16.3761 2.87618 15.7858 3.61078 14.6052C4.10278 13.8144 4.56568 12.7948 4.87528 11.5",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9242_35239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 24,
    fill: "white",
    transform: "translate(1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9242_35239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 22 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b57ee30e22d0f7b63893b1f5e664acb1.svg";
export { ForwardRef as ReactComponent };